import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';
import _isNil from 'lodash/isNil';

import URLS from 'constants/urls';

const UPLOAD_RETRY_LIMIT = 3;

const uploadPhoto = (client, venueId, photosData, attempt = 1) =>
  client
    .post(
      URLS.venue.photos(venueId),
      {
        photo_type: photosData.photoType,
        photo_content: photosData.photoContent,
      },
      {
        ignoreInternalError: true,
      }
    )
    .catch(error => {
      if (attempt <= UPLOAD_RETRY_LIMIT) {
        return uploadPhoto(client, venueId, photosData, attempt + 1);
      }
      throw error;
    });

const handler = ({ httpClient }, venueId, photosData) => {
  const endpoint = URLS.venue.photos(venueId);
  let promise = Promise.resolve();

  if (!_isNil(photosData)) {
    promise = uploadPhoto(httpClient, venueId, photosData);
  }

  return promise.then(() => httpClient.get(endpoint)).then(transformV2ClientResponse);
};

export default makeEntityScaffold('VENUE_PAGE_PHOTOS', handler, {
  defaultKey: (_, venueId, { photoType = '' } = {}) => {
    return `${venueId}${photoType}`;
  },
});
